const getClassName = (className, needClass) => {
  return needClass ? className : ''
}

const getAdminTheme = (data) => {
  if (data.color) {
    return null
  }

  return data.dark_mode
    ? 'white'
    : 'black'
}

const getStyles = (data) => {
  return `
    --tag-bg-color: ${data.background_color};
    --tag-text-color: ${data.color ? data.color : 'var(--admin-color)'}`
}

const getIcon = (name) => {
  const iconsMap = {
    like: 'ui-like-dark',
    star: 'ui-star-dark',
    flash: 'ui-flash-dark',
    percent: 'ui-percent-dark',
    'thumb-up': 'ui-thumb-up-dark',
    template: 'ui-template-dark'
  }

  return iconsMap[name] ?? `ui-${name}`
}

const getTagClassList = ({ data, size, type, theme, sizeMode, iconPosition }) => {
  return `ui-tag
    ui-tag--${size}
    ui-tag--${type}
    ui-tag--${theme}
    ${getClassName(`ui-tag--${sizeMode}`, sizeMode)}
    ${getClassName(`ui-tag--icon-${iconPosition}`, data.icon)}
  `
}

const getIconClassList = (iconPosition) => {
  return `ui-tag__icon
    ui-tag__icon--${iconPosition}
  `
}

const getIconTemplate = ({ data, iconClassList }) => {
  return `<svg class="${iconClassList}" width="12" href="12" aria-hidden="true">
    <use href="#${getIcon(data.icon)}"></use>
  </svg>`
}

const getTemplate = ({ data, iconClassList, tagClassList, classes }) => {
  return `<span
    ${getAdminTheme(data) ? `data-admin-theme="${getAdminTheme(data)}"` : ''}
    style="${getStyles(data)}"
    class="${tagClassList} ${classes}"
  >
    ${data.icon ? getIconTemplate({ data, iconClassList }) : ''}

    <span>
      ${data.title}
    </span>
  </span>`
}

export const UiTagVanilla = (
  {
    data = {},
    theme = 'filled',
    type = 'round',
    iconPosition = 'left',
    size = 'small',
    sizeMode = null,
    classes = ''
  }
) => {
  const tagClassList = getTagClassList({ data, size, type, theme, sizeMode, iconPosition })
  const iconClassList = getIconClassList(iconPosition)
  const options = { data, type, iconClassList, tagClassList, classes }

  return getTemplate(options)
}
